module.exports = __webpack_public_path__ + "img/capa1.7542f03e.webp";